// import React, { useState } from 'react';
// import './Usercompany.css';
// import AboutUs from './components/AboutUs';
// import Structure from './components/Structure';
// import Policies from './components/Policies';
// import Attendance from './components/Attendance';
// import Leave from './components/Leave';
// import Levels from './components/Levels';
// import Designation from './components/Designation';
// import Department from './components/Department';
// import Saturated from './components/Saturated';

// const Company = () => {
//   // Tab data with names and IDs
//   const tabs = [
//     { id: 1, name: "ABOUT US", component: AboutUs },
//     { id: 2, name: "STRUCTURE", component: Structure },
//     { id: 3, name: "POLICIES", component: Policies },
//     { id: 4, name: "ATTENDANCE", component: Attendance },
//     { id: 5, name: "LEAVE", component: Leave },
//     { id: 6, name: "LEVELS", component: Levels },
//     { id: 7, name: "DESIGNATION", component: Designation },
//     { id: 8, name: "DEPARTMENT", component: Department },
//     { id: 9, name: "SATURATED", component: Saturated }
//   ];

//   // State to track active tab
//   const [activeTab, setActiveTab] = useState(tabs[0].id);
  
//   // Get active component
//   const ActiveComponent = tabs.find(tab => tab.id === activeTab)?.component;

//   return (
//     <div className="company-container">
//       <h2 className="company-title">HR Management System</h2>
      
//       {/* Tabs Navigation */}
//       <div className="company-scroll-container">
//         <div className="company-buttons-row">
//           {tabs.map(tab => (
//             <button
//               key={tab.id}
//               className={`company-button ${activeTab === tab.id ? 'active' : ''}`}
//               onClick={() => setActiveTab(tab.id)}
//             >
//               <span className="company-button-text">{tab.name}</span>
//             </button>
//           ))}
//         </div>
//       </div>
      
//       {/* Scroll indicator for mobile */}
//       <div className="scroll-indicator">
//         <span className="scroll-hint">← Scroll →</span>
//         <span className="mobile-only">Swipe left/right on mobile</span>
//       </div>
      
//       {/* Active Component Display */}
//       <div className="component-display">
//         <div className="component-content">
//           {ActiveComponent ? <ActiveComponent /> : <AboutUs />}
//         </div>
//       </div>
//     </div>
//   );
// };

// export default Company;



import React, { useState } from "react";
import "./Usercompany.css";
import Aboutus from './Aboutus'
import Attendance from './Attendance';
import Structure from './Structure';
import Chartstructure from './Chartstructure';
import PolicyTable from './PolicyTable';

/* ---------- Dummy Section Component ---------- */
const DummySection = ({ title }) => {
  return (
    <div className="dummy-box">
      <h2>{title}</h2>
      <p>This is a dummy section for <strong>{title}</strong>.</p>
      <span>Content will be added later 🚧</span>
    </div>
  );
};

/* ---------- Main Company Component ---------- */
const Company = () => {
  const tabs = [
    { id: 1, name: "ABOUT US", component: () => <Aboutus title="About Us" /> },
    { id: 2, name: "STRUCTURE", component: () => <Chartstructure title="Company Structure" /> },
    { id: 3, name: "POLICIES", component: () => <PolicyTable title="Company Policies" /> },
    { id: 4, name: "ATTENDANCE", component: () => <Attendance title="Attendance Management" /> },
    { id: 5, name: "LEAVE", component: () => <DummySection title="Leave Management" /> },
    { id: 6, name: "LEVELS", component: () => <DummySection title="Employee Levels" /> },
    { id: 7, name: "DESIGNATION", component: () => <DummySection title="Designation" /> },
    { id: 8, name: "DEPARTMENT", component: () => <DummySection title="Department" /> },
    { id: 9, name: "SATURATED", component: () => <Structure title="Saturated Roles" /> },
  ];

  const [activeTab, setActiveTab] = useState(tabs[0].id);
  const ActiveComponent = tabs.find(tab => tab.id === activeTab)?.component;

  return (
    <div className="company-container">

      {/* 🔹 Inline CSS */}
      <style>{`
  /* Default (Mobile first) – kuch change nahi */
  .company-scroll-container {
    position: static;
    background: #fff;
  }

  .company-buttons-row {
    display: flex;
    // gap: 10px;
    flex-wrap: wrap;
  }

  .company-button {
    padding: 8px 16px;
    border: none;
    background: #f0f0f0;
    cursor: pointer;
    border-radius: 6px;
    white-space: nowrap;
  }

  .company-button.active {
    background: #7564e6;
    color: #fff;
  }

  /* ✅ Desktop / Laptop only */
  @media (min-width: 769px) {
    .company-scroll-container {
      position: sticky;
      top: 0;
      z-index: 100;
      padding: 10px 0;
    }
  }
`}</style>


      {/* Tabs */}
      <div className="company-scroll-container">
        <div className="company-buttons-row">
          {tabs.map(tab => (
            <button
              key={tab.id}
              className={`company-button ${activeTab === tab.id ? "active" : ""}`}
              onClick={() => setActiveTab(tab.id)}
            >
              {tab.name}
            </button>
          ))}
        </div>
      </div>

      {/* Active Section */}
      <div className="component-display">
        {ActiveComponent && <ActiveComponent />}
      </div>
    </div>
  );
};


export default Company;
